import { Section, SectionSummary } from '@module/form';

/**
 * Creates a display-only section copy when persisted system defaults need localization.
 * The original domain entity is never mutated.
 */
export var createSectionPreviewDisplay = function createSectionPreviewDisplay(section, presentation) {
  var sectionDefaults = presentation === null || presentation === void 0 ? void 0 : presentation.sectionDefaults;
  if (!sectionDefaults) return section;
  var title = section.title === sectionDefaults.title.persisted ? sectionDefaults.title.display : section.title;
  var description = section.description === sectionDefaults.description.persisted ? sectionDefaults.description.display : section.description;
  if (title === section.title && description === section.description) return section;

  if (section instanceof Section) {
    var displaySection = section.clone();
    displaySection.updateTitle(title);
    displaySection.updateDescription(description);
    return displaySection;
  }

  return SectionSummary.create({
    id: section.id.toString(),
    formId: section.formId,
    title: title,
    description: description,
    totalScore: section.totalScore,
    totalQuestion: section.totalQuestion,
    index: section.index,
    previousSectionId: section.previousSectionId,
    displayType: section.displayType,
    audioFile: section.audioFile
  }).getValue();
};